import { render, staticRenderFns } from "./TreeMenu.vue?vue&type=template&id=1b5c7935&scoped=true"
import script from "./TreeMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./TreeMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TreeMenu.vue?vue&type=style&index=0&id=1b5c7935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c7935",
  null
  
)

export default component.exports